import React, { useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { _ } from '_locales';

import { alert as alertSetup } from '_actions';

const WholeModalContainer = styled.div`
  position: absolute;
  z-index: 999999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 0;
  margin: 0;
  background-color: #252525;
  opacity: .5;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  transition-property: opacity, visibility;
  transition-timing-function: linear;
  transition-duration: 250ms;
  cursor: alias;
`;

const ModalBox = styled.div`
  font-size: 17px !important;
  border-radius: 10px !important;
  box-shadow: 0 10px 10px -5px #6f6f6f;
  line-height: 1.7em;
  position: absolute;
  background-color: #ffffff;
  max-width: 550px;
  width: calc(100% - 30px);
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999999;

  animation: fadeIn .3s;
  -webkit-animation: fadeIn .3s;
  -moz-animation: fadeIn .3s;
  -o-animation: fadeIn .3s;
  -ms-animation: fadeIn .3s;

  @keyframes fadeIn {
    0% {opacity:0;}
    100% {opacity:1;}
  }

  @-moz-keyframes fadeIn {
    0% {opacity:0;}
    100% {opacity:1;}
  }

  @-webkit-keyframes fadeIn {
    0% {opacity:0;}
    100% {opacity:1;}
  }

  @-o-keyframes fadeIn {
    0% {opacity:0;}
    100% {opacity:1;}
  }

  @-ms-keyframes fadeIn {
    0% {opacity:0;}
    100% {opacity:1;}
  }
`;

const Content = styled.div`
  padding: 36px 47px;
  box-sizing: border-box;
  border: 0;
  font-size: 17px !important;
  font-weight: 400 !important;
  line-height: 1.7em;
  min-height: 56px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 25px 0;
  box-sizing: border-box;
`;

const Button = styled.button`
  background-color: #01288f;
  border: none;
  cursor: pointer;
  border-radius: 7px;
  color: white;
  font-size: 14px !important;
  min-width: 88px;
  min-height: 35px;
  margin: 4px;
`;

const AlertIt = ({
  text = '',
  modalType,
  onCancel,
  setModalType,
  setIsModalOpen,
  setModalConfirmAction,
  modalConfirmActionCallback,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  const clickHandler = (callBack) => {
    setIsOpen(false);
    if (typeof callBack === 'function') {
      callBack();
    }
  };

  return (
    isOpen ? (
      <div>
        <WholeModalContainer onClick={() => clickHandler(onCancel)} />
        <ModalBox>
          <Content>
            <div>
              {text}
            </div>
          </Content>
          <ButtonContainer>
            {
              modalType
                && modalType === 'question'
                ? (
                  <div>
                    <Button
                      onClick={() => clickHandler(() => {
                        setModalType('alert');
                        setIsModalOpen(false);
                        if (modalConfirmActionCallback) {
                          modalConfirmActionCallback();
                        }
                      })}
                      aria-label="confirm"
                    >
                      {_('general.yes')}
                    </Button>
                    <Button onClick={() => clickHandler(onCancel)} aria-label="cancel">
                      {_('general.no')}
                    </Button>
                  </div>
                ) : (
                  <Button
                    onClick={() => {
                      clickHandler(onCancel);
                      if (modalConfirmActionCallback) {
                        modalConfirmActionCallback();
                      }
                    }}
                    aria-label="confirm"
                  >
                    {_('general.ok')}
                  </Button>
                )
            }
          </ButtonContainer>
        </ModalBox>
      </div>
    ) : null
  );
};

const mapStateToProps = (state) => ({
  modalType: state.alert.modalType,
  modalConfirmActionCallback: state.alert.modalConfirmActionCallback,
});

const setDispatchToProps = (dispatch) => ({
  setModalConfirmAction: (modalConfirmAction) => dispatch(
    alertSetup.setModalConfirmAction(modalConfirmAction)
  ),
  setModalType: (modalType) => dispatch(alertSetup.setModalType(modalType)),
  setIsModalOpen: (isModalOpen) => dispatch(alertSetup.setIsModalOpen(isModalOpen)),
});

export default connect(mapStateToProps, setDispatchToProps)(AlertIt);
